import { organisationSignal } from "../../../../signal/organisationSignal";

export const  TallyConfig = {
    "host": `http://${organisationSignal?.value?.tallyConfig?.hostIP || "localhost"}`,
    "port": organisationSignal?.value?.tallyConfig?.port || 9000,
    "company": "TEST",
    "tallySyncFromDate": "2024/04/01",
    "tallyLastSyncDate": "2024/04/01"
}


export const setTallyConfig = (company) => {
    TallyConfig.host = `http://${organisationSignal?.value?.tallyConfig?.hostIP || "localhost"}`;
    TallyConfig.port = organisationSignal?.value?.tallyConfig?.port || 9000;
    TallyConfig.company = company?.companyName || "TEST";
    TallyConfig.tallySyncFromDate = company?.syncFromDate || "2024/04/01";

    if(company?.lastSyncDate && company?.lastSyncDate==="") {
        TallyConfig.tallyLastSyncDate = "2024/04/01";
    }

    TallyConfig.tallyLastSyncDate = company?.lastSyncDate || "2024/04/01";
}
